module.exports = __webpack_public_path__ + "media/images/shared/delivery/sherl-6ac974c96e73e5cf552952884aa2b279.jpg";